import { render } from "./BlockedDomains.vue?vue&type=template&id=3957d574&scoped=true"
import script from "./BlockedDomains.vue?vue&type=script&lang=js"
export * from "./BlockedDomains.vue?vue&type=script&lang=js"

import "./BlockedDomains.vue?vue&type=style&index=0&id=3957d574&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3957d574"]])

export default __exports__